import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Description2bxny7ww0bbw3 as Description } from '../../lightningdb/Annotations.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  LongSerializer_getInstance194e4t3ow5wjs as LongSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { $serializer_getInstance3d2qec0zxd66 as $serializer_getInstance } from '../LSError.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.typed.BulkResponse', this, 3);
        tmp0_serialDesc.c1b('result', true);
        tmp0_serialDesc.d1b(new (Description())('JSON'));
        tmp0_serialDesc.c1b('error', true);
        tmp0_serialDesc.c1b('durationMs', true);
        this.o4p_1 = tmp0_serialDesc;
      }
      p4p(encoder, value) {
        var tmp0_desc = this.o4p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.q4p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.q4p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.r4p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, $serializer_getInstance(), value.r4p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.s4p_1 === 0n)) {
          tmp1_output.w14(tmp0_desc, 2, value.s4p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.p4p(encoder, value instanceof BulkResponse() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.o4p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0n;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.z13(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.r13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return BulkResponse().t4p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.o4p_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance()), LongSerializer_getInstance()];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var BulkResponseClass;
function BulkResponse() {
  if (BulkResponseClass === VOID) {
    class $ {
      constructor(result, error, durationMs) {
        result = result === VOID ? null : result;
        error = error === VOID ? null : error;
        durationMs = durationMs === VOID ? 0n : durationMs;
        this.q4p_1 = result;
        this.r4p_1 = error;
        this.s4p_1 = durationMs;
      }
      toString() {
        return 'BulkResponse(result=' + this.q4p_1 + ', error=' + toString(this.r4p_1) + ', durationMs=' + this.s4p_1.toString() + ')';
      }
      hashCode() {
        var result = this.q4p_1 == null ? 0 : getStringHashCode(this.q4p_1);
        result = imul(result, 31) + (this.r4p_1 == null ? 0 : this.r4p_1.hashCode()) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.s4p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BulkResponse()))
          return false;
        if (!(this.q4p_1 == other.q4p_1))
          return false;
        if (!equals(this.r4p_1, other.r4p_1))
          return false;
        if (!(this.s4p_1 === other.s4p_1))
          return false;
        return true;
      }
      static t4p(seen0, result, error, durationMs, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().o4p_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.q4p_1 = null;
        else
          $this.q4p_1 = result;
        if (0 === (seen0 & 2))
          $this.r4p_1 = null;
        else
          $this.r4p_1 = error;
        if (0 === (seen0 & 4))
          $this.s4p_1 = 0n;
        else
          $this.s4p_1 = durationMs;
        return $this;
      }
    }
    initMetadataForClass($, 'BulkResponse', BulkResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    BulkResponseClass = $;
  }
  return BulkResponseClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.typed.BulkRequest', this, 3);
        tmp0_serialDesc.c1b('path', false);
        tmp0_serialDesc.c1b('method', false);
        tmp0_serialDesc.c1b('body', true);
        tmp0_serialDesc.d1b(new (Description())('JSON'));
        this.u4p_1 = tmp0_serialDesc;
      }
      v4p(encoder, value) {
        var tmp0_desc = this.u4p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.w4p_1);
        tmp1_output.a15(tmp0_desc, 1, value.x4p_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.y4p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.y4p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.v4p(encoder, value instanceof BulkRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.u4p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return BulkRequest().z4p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.u4p_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var BulkRequestClass;
function BulkRequest() {
  if (BulkRequestClass === VOID) {
    class $ {
      constructor(path, method, body) {
        body = body === VOID ? null : body;
        this.w4p_1 = path;
        this.x4p_1 = method;
        this.y4p_1 = body;
      }
      toString() {
        return 'BulkRequest(path=' + this.w4p_1 + ', method=' + this.x4p_1 + ', body=' + this.y4p_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.w4p_1);
        result = imul(result, 31) + getStringHashCode(this.x4p_1) | 0;
        result = imul(result, 31) + (this.y4p_1 == null ? 0 : getStringHashCode(this.y4p_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BulkRequest()))
          return false;
        if (!(this.w4p_1 === other.w4p_1))
          return false;
        if (!(this.x4p_1 === other.x4p_1))
          return false;
        if (!(this.y4p_1 == other.y4p_1))
          return false;
        return true;
      }
      static z4p(seen0, path, method, body, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_1().u4p_1);
        }
        var $this = createThis(this);
        $this.w4p_1 = path;
        $this.x4p_1 = method;
        if (0 === (seen0 & 4))
          $this.y4p_1 = null;
        else
          $this.y4p_1 = body;
        return $this;
      }
    }
    initMetadataForClass($, 'BulkRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    BulkRequestClass = $;
  }
  return BulkRequestClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  BulkRequest as BulkRequest1ynbxhwj3d4b2,
  BulkResponse as BulkResponsenhuw5ggnccvl,
  Companion_instance_0 as Companion_instancedr8ewd9slv0o,
  Companion_instance as Companion_instancevf9zg0jswem5,
};
//endregion

//# sourceMappingURL=BulkRequest.mjs.map
